export const WORKFLOW_EVENT_BASE_URL = 'event-catalog';
